<app-shared-loading *ngIf="loading"></app-shared-loading>
<div *ngIf="visualizeSubMenu">
  <div class="general-title">
    <h1 class="pl-1 title">{{ 'choose-method' | translation | async }}</h1>
  </div>
  <app-return-methods
    [itsMobileCtrl]="true"
    [unique]="this.transaction.ORDER_METHOD"
    (RT)="changeMethod()">
  </app-return-methods>
  <div class="contentBox">
    <div class="center col-3">
      <div class="info-logo-container">
        <img [src]="logo" class="payment_method_no_interactive" alt="logo Banco nacional"/>
      </div>
      <h2 class="pl-align">{{ 'from-banks' | translation | async }}</h2>
    </div>
    <div class="col-7">
      <div class="methodInfo">
        <app-return-methods
          *ngIf="visibleReturnPayMethods"
          [itsMobileCtrl]="false"
          [unique]="''"
          (RT)="changeMethod()">
        </app-return-methods>
        <br>
        <br>
        <mat-card-content *ngIf="visualizeUserForm">
          <form name="userData" id="userData">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'forms-Full-Name' | translation | async }}</mat-label>
              <input
                #fullName
                type="text"
                name="fullName"
                matInput [formControl]="fullNameFormControl"
                [(ngModel)]="userDataModel.fullName"
                placeholder="{{ 'forms-Full-Name' | translation | async }}"/>
              <mat-hint align="end">{{fullName.value?.length || 0}}/50</mat-hint>
              <mat-error *ngIf="fullNameFormControl.hasError('pattern')">
                {{ 'forms-specialCharacter' | translation | async }}
              </mat-error>
              <mat-error *ngIf="fullNameFormControl.hasError('required')">
                {{ 'forms-required-field' | translation | async }}
              </mat-error>
              <mat-error *ngIf="fullNameFormControl.hasError('maxlength')">
                {{ 'forms-maxLength' | translation | async }}
              </mat-error>
              <mat-error *ngIf="fullNameFormControl.hasError('minlength')">
                {{ 'forms-minLength' | translation | async }}
              </mat-error>
            </mat-form-field>
            <br>
            <div class="checkbox">
              <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>

            </div>
          </form>
        </mat-card-content>

        <mat-card-content *ngIf="!enableContinue && visualizeUserForm" class="sub-menu">
          <div *ngFor="let payment of paymentsSubMenu">
            <a class="sub-menu-button" mat-flat-button disabled>
              <div class="button-content">
                <h3>{{ paymentsMethods[payment.code]['name']}}</h3>
                <h4
                  *ngIf="paymentsMethods[payment.code]['approve']">{{ 'immediate-approval' | translation | async }}</h4>
              </div>
            </a>
          </div>
        </mat-card-content>

        <mat-card-content *ngIf="enableContinue || !visualizeUserForm" class="sub-menu">
          <div *ngFor="let payment of paymentsSubMenu" (click)="methods(payment)">
            <a class="sub-menu-button" mat-flat-button>
              <div class="button-content">
                <h3>{{ paymentsMethods[payment.code]['name']}}</h3>
                <h4
                  *ngIf="paymentsMethods[payment.code]['approve']">{{ 'immediate-approval' | translation | async }}</h4>
              </div>
            </a>
          </div>
        </mat-card-content>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!visualizeSubMenu">
  <div class="general-title">
    <h1 class="pl-1 title">{{ 'steps-complete-payment' | translation | async }}</h1>
  </div>
   <app-return-methods
    [itsMobileCtrl]="true"
    [unique]="this.transaction.ORDER_METHOD"
    (RT)="changeMethod()">
  </app-return-methods>
  <div class="contentBox">
    <div class="center col-3">
      <div class="info-logo-container">
        <img [src]="payment.logo" class="payment_method_no_interactive" [alt]="payment.name"/>
      </div>
      <h2 class="pl-align">{{paymentsMethods[payment.code]['name']}}</h2>
    </div>
    <div class="col-7">
      <div class="methodInfo">
        <app-return-methods
          *ngIf="visibleReturnPayMethods"
          [itsMobileCtrl]="false"
          [unique]="''"
          (RT)="changeMethod()">
        </app-return-methods>
        <br>
        <br>
        <div *ngIf="visualizePayWeb">
          <app-payment-from-website
            [transaction]="transaction"
          >
          </app-payment-from-website>
        </div>
        <div *ngIf="visualizeCash">
          <app-efectivo
            [info]="payment"
            [transaction]="transaction"
            [currentConcept]="payment.concept[0]">
          </app-efectivo>
        </div>
        <div *ngIf="visualizeDeposit">
          <app-deposit
            [info]="payment"
            [currentConcept]="payment.concept[0]"
            [flagActive]="flagActive"
            (buttonStateChange)="handleButtonStateChange($event)"
            (click)="setInfo(CONCEPTS.DEPOSIT)"
          >
          </app-deposit>
        </div>
        <div *ngIf="visualizeTransfer">
          <app-transfer
            [info]="payment"
            [currentConcept]="payment.concept[0]"
            (buttonStateChange)="handleButtonStateChange($event)"
            (click)="setInfo(CONCEPTS.TRANSFER)"
          >
          </app-transfer>
        </div>
      </div>
      <app-buttons-bar *ngIf="(visualizeTransfer || visualizeDeposit)"
                       [template]="payment.template" [valid]="valid" [nameCustom]="'Enviar'"
                       [valid]="buttonEnabledInSubMenu"
                       (CUSTOM)="finalize()">
      </app-buttons-bar>
      <ng-container *ngIf="(visualizeCash || visualizeDeposit || visualizeTransfer) && merchantHasWallet && bannerRecommedationFF && bannerRecommedationUiFixFF">
        <div [ngClass]="{'recomendationBannerMobileClassCash': bannerRecommedationUiFixFF && visualizeCash,
                        'recomendationBannerMobileClassDeposit': bannerRecommedationUiFixFF && (visualizeDeposit || visualizeTransfer) }">
          <app-recommendations-banner [bannerText]="bannerText"></app-recommendations-banner>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="(visualizeCash || visualizeDeposit || visualizeTransfer) && merchantHasWallet && bannerRecommedationFF" >
    <div [ngClass]="{'recomendationBannerClass': bannerRecommedationUiFixFF}">
      <br>
      <app-recommendations-banner [bannerText]="bannerText"></app-recommendations-banner>
    </div>
  </ng-container>
</div>
